import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useUtmCapture, getUtmData } from '../hooks/useUtm';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const usePageTracker = () => {
  const location = useLocation();
  useUtmCapture();

  useEffect(() => {
    const trackVisit = async () => {
      try {
        const utm = getUtmData();
        await axios.post(`${API_URL}/api/analytics/track`, {
          page: location.pathname,
          referrer: document.referrer || null,
          user_agent: navigator.userAgent,
          country: null,
          ...utm,
        });
      } catch (error) {
        // analytics tracking failure is non-critical
      }
    };
    trackVisit();
  }, [location.pathname]);
};

export const PageTracker = () => {
  usePageTracker();
  return null;
};

export default PageTracker;
